/**
 * Author:Qian.qianchen
 *
 * Time:2019-01-21
 */
"use strict";
angular.module('customSentimentServiceModule', ['settingSentimentModule'])
    .factory('customSentimentService', ['$q', '$modal', 'trsHttpService', function($q, $modal, trsHttpService) {
        return {
            settingSentiment: function(nav,success,cancel) {
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/realTimeClues/suddenClues/customSentiment/services/settingSentiment/settingSentiment_tpl.html",
                    windowClass: "setting-sentiment-modal",
                    controller: "settingSentimentCtrl",
                    backdrop:false,
                    resolve: {
                        nav: function() {
                            return nav;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    if (result === false) {
                        cancel();
                        return;
                    }
                    success(result);
                });
            }
        };
    }]);